export const contactData = {
    phone: "+420 737 235 896",
    mail: "studio@stablerecords.cz",
    address: "U jednoty 1141, Březová-Oleško, 25245, Czech Republic",
    name: "Jan Maštalíř"
};